import actions from 'od-modules/secure_store/actions';
import {dispatch} from 'od-modules/secure_store/store';
import trackingUtils from 'od-modules/utils/tracking.utils';

const DEFAULT_EXPIRING_CREDIT_CARD = false;
const TRACKING_CATEGORY = 'flights_pay_page';
const TRACKING_EXPIRING_ACTION = 'payment_details_error';
const TRACKING_EXPIRING_LABEL = 'ccard_expiring_inline_error_time';

export default Backbone.Model.extend({
    silentChange: false,
    connect: true,
    selectors: ['pricing', 'primeMemberSelected'],
    defaults: {
        cardExpirationMonth: null,
        cardExpirationYear: null,
        cardExpirationDate: null,
        isExpiringCard: false,
        ccard_expiring_inline_error_time: 0,
        isPreviousCreditCardRisky: false,
    },

    initialize() {
        dispatch({type: actions.SET_EXPIRING_CREDIT_CARD, entry: DEFAULT_EXPIRING_CREDIT_CARD});

        this.listenTo(this, 'change:cardExpirationMonth', this.setCardExpirationDate);
        this.listenTo(this, 'change:cardExpirationYear', this.setCardExpirationDate);
        this.listenTo(this, 'change:cardExpirationDate', this.setExpiringCard);
    },

    setCardExpirationDate() {
        const cardExpirationMonth = this.get('cardExpirationMonth');
        const cardExpirationYear = this.get('cardExpirationYear');
        const isValidMonth = this.isValidMonth(cardExpirationMonth);
        const isValidYear = this.isValidYear(cardExpirationYear);

        this.set(
            'cardExpirationDate',
            isValidMonth && isValidYear ? new Date(`20${cardExpirationYear}-${cardExpirationMonth}`) : this.defaults.cardExpirationDate
        );
    },

    isBetweenCurrentAndNextMonth(date) {
        const today = new Date();
        const currentMonthDate = this.addMonthsToDate(today);
        const nextMonthDate = this.addMonthsToDate(today, 1);
        return date >= currentMonthDate && date <= nextMonthDate;
    },

    isExpiringCard() {
        const cardExpirationDate = this.get('cardExpirationDate');
        return !!cardExpirationDate && this.isBetweenCurrentAndNextMonth(cardExpirationDate);
    },

    setExpiringCard() {
        const initValue = this.isExpiringCard();
        const {isSubscriptionAdded} = this.get('primeMemberSelected');
        const value = isSubscriptionAdded || this.get('isPreviousCreditCardRisky') ? initValue : false;
        dispatch({type: actions.SET_MEMBERSHIP_CHURN_RISK, entry: {isExpiringCreditCard: initValue}});
        this.setExpiringCountAndTrack(value);
        this.set({isExpiringCard: value});
        this.setPreviousCreditCardRisky(isSubscriptionAdded || value);
        dispatch({type: actions.SET_EXPIRING_CREDIT_CARD, entry: value});
    },

    setPreviousCreditCardRisky(value) {
        this.set({isPreviousCreditCardRisky: value});
    },

    setExpiringCountAndTrack(value) {
        if (value) {
            let count = this.get(TRACKING_EXPIRING_LABEL);
            this.set(TRACKING_EXPIRING_LABEL, ++count);
            this.track(TRACKING_EXPIRING_ACTION, TRACKING_EXPIRING_LABEL);
        }
    },

    track(action, label) {
        const count = this.get(TRACKING_EXPIRING_LABEL);
        trackingUtils.trackEventWithCategory(TRACKING_CATEGORY, action, `${label}:${count}`);
    },

    isValidMonth(month) {
        return parseInt(month) >= 1 && parseInt(month) <= 12;
    },

    isValidYear(year) {
        return parseInt(year) >= 0 && parseInt(year) <= 99;
    },

    addMonthsToDate(date, months = 0) {
        return new Date(Date.UTC(date.getFullYear(), date.getMonth() + months));
    },
});
